import { EditOutlined, EllipsisOutlined, CheckCircleOutlined, MenuOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { useNavigate } from 'react-router';

import { useUpdateSchoolDataMutation } from '@/api/endpoints/schools';
import { DropdownLabel } from '@/shared/components';
import { ROUTES } from '@/shared/consts';
import { useApiRequest } from '@/shared/hooks/useApiRequest';
import { ESchoolType } from '@/shared/types';

import styles from '../../Dropdown.module.scss';

type TProps = {
  id: number;
  schoolType: ESchoolType;
};

export const UnpublishedDropdown = ({ id, schoolType }: TProps) => {
  const [updateSchoolData, { isLoading: isUpdatingSchoolData }] = useUpdateSchoolDataMutation();

  const sendApiRequest = useApiRequest();

  const navigate = useNavigate();

  const publishSchoolHandler = async () => {
    await sendApiRequest({
      successMessage: 'Школа опубликована',
      apiRequestCallback: () =>
        updateSchoolData({
          id,
          data: {
            active: true,
          },
        }),
    });
  };

  const dropdownItems: MenuProps['items'] = [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: (
        <DropdownLabel
          text="Редактирование"
          onClick={() => navigate(`${id}/${ROUTES.EDIT}`)}
        />
      ),
    },
    {
      key: 'publish',
      disabled: isUpdatingSchoolData,
      icon: <CheckCircleOutlined />,
      label: (
        <DropdownLabel
          text="Опубликовать"
          onClick={publishSchoolHandler}
        />
      ),
    },
  ];

  if (schoolType === ESchoolType.Public) {
    dropdownItems.push({
      key: 'selection-panel',
      icon: <MenuOutlined />,
      label: (
        <DropdownLabel
          text="Панель отбора"
          onClick={() => navigate(`${id}/${ROUTES.SELECTION_PANEL}`)}
        />
      ),
    });
  }

  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        items: dropdownItems,
        onClick: (dropdownItem) => {
          dropdownItem.domEvent.stopPropagation();
        },
      }}
      classNames={{
        root: styles['dropdown-overlay'],
      }}
    >
      <Button
        className={styles['dropdown-button']}
        onClick={(evt) => evt.stopPropagation()}
      >
        <EllipsisOutlined />
      </Button>
    </Dropdown>
  );
};
